import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';

export const useDeleteTransferRecord = (transferId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (recordId) =>
      apiClient.delete(`/v1/projects/${projectId}/transfers/${transferId}/records/${recordId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
      queryClient.invalidateQueries({ queryKey: ['transfer', transferId] });
    },
  });
};
